import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWindow: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="window, timeline, feed, posts"><path d="M3.75 10.75V3.75H20.25V10.75M3.75 10.75V20.25H20.25V10.75M3.75 10.75H20.25M10.75 7.25H17.25M8.25 7.25C8.25 7.66421 7.91421 8 7.5 8C7.08579 8 6.75 7.66421 6.75 7.25C6.75 6.83579 7.08579 6.5 7.5 6.5C7.91421 6.5 8.25 6.83579 8.25 7.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconWindow;
